import React, { createContext, useContext, useState, useCallback, type ReactNode } from 'react';

interface SlugTranslationsContextType {
  slugTranslations: Record<string, string> | null;
  setSlugTranslations: (_translations: Record<string, string> | null) => void;
}

const SlugTranslationsContext = createContext<SlugTranslationsContextType | undefined>(undefined);

export const SlugTranslationsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [slugTranslations, setSlugTranslationsState] = useState<Record<string, string> | null>(null);

  const setSlugTranslations = useCallback((translations: Record<string, string> | null) => {
    setSlugTranslationsState(translations);
  }, []);

  return (
    <SlugTranslationsContext.Provider value={{ slugTranslations, setSlugTranslations }}>
      {children}
    </SlugTranslationsContext.Provider>
  );
};

export const useSlugTranslations = (): SlugTranslationsContextType => {
  const context = useContext(SlugTranslationsContext);
  if (!context) {
    throw new Error('useSlugTranslations must be used within a SlugTranslationsProvider');
  }
  return context;
};
